import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLargeLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M14.7672 2.07732C15.0007 2.22478 15.0704 2.53359 14.923 2.76706L9.59749 11.1991C9.28847 11.6884 9.28847 12.3118 9.59749 12.8011L14.923 21.2331C15.0704 21.4665 15.0007 21.7754 14.7672 21.9228C14.5337 22.0703 14.2249 22.0005 14.0775 21.7671L8.752 13.3351C8.23696 12.5196 8.23696 11.4806 8.752 10.6651L14.0775 2.23307C14.2249 1.99959 14.5337 1.92986 14.7672 2.07732Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeLeft;
